import { Card, CardHeader, CardTitle } from "@buddy/ui";
import { createFileRoute, Outlet } from "@tanstack/react-router";
import { SettingsSidebar } from "@/features/settings/settings-sidebar";

// Settings has its own sidebar instead of the chat one; each page renders into the card body.
export const Route = createFileRoute("/_app/settings")({ component: SettingsLayout });

function SettingsLayout() {
  return (
    <>
      <SettingsSidebar />
      <Card className="flex-1">
        <CardHeader>
          <CardTitle>Settings</CardTitle>
        </CardHeader>
        <div className="min-h-0 flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </Card>
    </>
  );
}
